import "react-table/react-table.css";

import { Dropdown, Grid, MenuItem, Row, Button } from "react-bootstrap";
import React, { useEffect } from "react";
import ReactTable, { ReactTableDefaults } from "react-table";
import { compose, pure, withHandlers, withState } from "recompose";

import { CSVLink } from "react-csv";
// import CostsChart from "../../components/Cost/CostsChart";
import CurrencySpan from "../../components/Currency/CurrencySpan";
import CustomButton from "../CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import Pagination from "./Pagination";
import SmallInputCell from "../../elements/CustomInput/SmallInputCell";
import Switch from "react-bootstrap-switch";
import _ from "lodash-es";
import exelIcon from "../../assets/img/excel.svg";
import { injectIntl } from "react-intl";
import moment from "moment";
import { viewPortDimension } from "../../tools/viewportDimension";
import { withRouter } from "react-router-dom";

import { formatPhoneNumber } from "react-phone-number-input";

import Checkbox from "../../elements/CustomCheckbox/CustomCheckbox.jsx";
import { v4 } from "uuid";

// import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

// import PropTypes from "prop-types";

const tableState = withState("tableState", "setTableState", ({ tableName }) => {
  // const s = sessionStorage.getItem(`${tableName}TableState`);
  // console.log("tableState", s);
  return null;
});

const rowSelected = withState("rowSelected", "setRowSelected", []);

const lastVisitedState = withState(
  "lastVisited",
  "setLastVisited",
  ({ tableName }) => {
    const state = sessionStorage.getItem(`${tableName}TableLastVisited`);
    return state;
  }
);

const filterState = withState(
  "filterState",
  "setFilterState",
  ({ tableName, history }) => {
    // return sessionStorage.getItem(`${tableName}TableStateFilter`);
    let s = restoreState(tableName, "TableStateFilter", history);
    // console.log("53 - s=", s);
    return s ? s : null;
  }
);

const toggledOn = withState(
  "toggledOn",
  "setToggle",
  ({ tableName, history, showFilter }) => {
    let s = restoreState(tableName, "TableStateToggleOn", history);
    // console.log("62 - s=", s);
    return s ? s : showFilter !== undefined ? showFilter : true;
  }
);

const sortedState = withState(
  "sortedState",
  "setSortedState",
  ({ tableName, history, onSortedChange }) => {
    let s = restoreState(tableName, "TableStateSorted", history);
    if (s && onSortedChange) {
      onSortedChange(s);
    }
    return s ? s : null;
  }
);

const pageState = withState(
  "pageState",
  "setPageState",
  ({ tableName, history }) => {
    let s = restoreState(tableName, "TableStatePage", history);
    // console.log("80 - s=", s);
    return s ? s : null;
  }
);

const pageSizeState = withState(
  "pageSizeState",
  "setPageSizeState",
  ({ history }) => {
    let s = restoreState("", "TableStatePageSize", null);
    // console.log("89 - s=", s);
    return s ? s : null;
  }
);

const expandedState = withState(
  "expandedState",
  "setExpandedState",
  ({ tableName, history }) => {
    let s = restoreState(tableName, "TableStateExpanded", history);
    // console.log("98 - s=", s);
    return s ? s : null;
  }
);

const windowScrollState = withState(
  "windowScrollState",
  "setWindowScrollState",
  ({ tableName, history }) => {
    let yPosition = restoreState(
      tableName,
      "TableStateScrollPosition",
      history
    );

    // console.log("restoring windowScrollState", yPosition);
    return yPosition ? yPosition : null;
  }
);
const exportToggle = withState("exportToggle", "setExportToggle", false);

const saveState = (
  tableName,
  toggledOn,
  filterState,
  sortedState,
  pageState,
  pageSizeState,
  expandedState
) => {
  // console.log(
  //   "saveState",
  //   tableName,
  //   toggledOn,
  //   filterState,
  //   sortedState,
  //   pageState,
  //   expandedState
  // );
  sessionStorage.setItem(
    `${tableName}TableStateToggleOn`,
    JSON.stringify(toggledOn)
  );
  sessionStorage.setItem(
    `${tableName}TableStateFilter`,
    JSON.stringify(filterState)
  );
  sessionStorage.setItem(
    `${tableName}TableStateSorted`,
    JSON.stringify(sortedState)
  );
  sessionStorage.setItem(
    `${tableName}TableStatePage`,
    JSON.stringify(pageState)
  );
  sessionStorage.setItem(
    `TableStatePageSize`,
    JSON.stringify(pageSizeState)
  );
  sessionStorage.setItem(
    `${tableName}TableStateExpanded`,
    JSON.stringify(expandedState)
  );
  sessionStorage.setItem(
    `${tableName}TableStateScrollPosition`,
    (window && window.scrollY) || 0
  );
};

const restoreState = (tableName, stateName, history) => {

  if (history === null || history.action === "POP") {
    const r = sessionStorage.getItem(`${tableName}${stateName}`);
    if (r === null || r === undefined)
      return null;
    try {
      JSON.parse(r);
    }
    catch (e) {
      return null;
    }
    return (r !== null && r !== undefined) ? JSON.parse(r) : r;
  }
};

const filterHandlers = {
  show: ({ setToggle }) => e => setToggle(true),
  hide: ({ setToggle }) => e => setToggle(false),
  toggle: ({ setToggle, setFilterState, toggledOn, tableName }) => e => {
    setToggle(current => !current);
    setFilterState([]);
  },
  toggleExport: ({ setExportToggle }) => e =>
    setExportToggle(current => !current)
};

let convertToCsvExport = (
  columns,
  data,
  intl,
  locale,
  filterState,
  sortedState
) => {
  let dataExport = ""; // [];
  let titleLine = ""; // [];

  columns.forEach(c => {
    if (c.exportColumn !== false)
      if (c.noTranslateColumnName === true)
        // itleLine.push(c.name);
        titleLine = titleLine + `"` + c.name + `";`;
      else
        // titleLine.push(intl.formatMessage({ id: `ids_` + c.name }));
        titleLine = titleLine + `"` + intl.formatMessage({ id: `ids_` + c.name }) + `";`;
  });

  // dataExport.push(titleLine);
  dataExport = dataExport + titleLine + `\r\n`;

  // console.log("188 - columns", columns);

  data &&
    data.forEach(d => {

      let addExport = true;
      let line = [];

      columns.forEach(c => {
        if (c.exportColumn !== false) {
          let col = "";
          if (c.export) {
            col = c.export(d);
          } else {
            if (c.accessor) {
              const type = typeof c.accessor;
              if (type === "function") {
                col = c.accessor(d); // need specific - exporAccessor and exportable - flags

                if (col !== "" && c.type === "currency") {
                  col = Math.round(col * 100) / 100;
                  col = col.toString();
                  col = col.replace(".", ",");
                }
              } else {
                col = _.get(d, c.accessor); // need specific - exporAccessor and exportable - flags

                if (c.accessor && c.accessor === "dateEcheance") {
                  col = moment().diff(col, "days");
                  if (d.status && d.status !== "DUE") {
                    //si le status est pas Du affiché 0
                    col = 0;
                  }
                } else if (c.type && c.type === "currency") {
                  // console.log("232 - c=", c);

                  if (c.currencyDebit === "true") {
                    if (col <= 0) col = "";
                  } else {
                    if (c.currencyCredit === "true") {
                      if (col > 0) col = "";
                      else col = -col;
                    }
                  }
                  if (col !== "") {
                    //Arrondi des chiffres
                    col = Math.round(col * 100) / 100;
                    col = col.toString();
                    col = col.replace(".", ",");
                  }
                } else if (c.type && c.type === "date") {
                  // enlever le superflux des dates                
                  if (col !== "") {
                    col = moment(col).format("L");
                  }
                } else if (c.type && c.type === "tax") {
                  // enlever le superflux des dates
                  if (col) col = col + "%";
                  else col = "";
                } else if (c.type && c.type === "categoryActive") {
                  // traduire le chmp des status
                  if (col === true)
                    col = intl.formatMessage({ id: `ids_active` });
                  else col = intl.formatMessage({ id: `ids_inactive` });
                }
              }
            } else {
              col = d[c.name];
            }
          }
          // console.log("306 - col=", col);

          // line.push(col);
          if (col === undefined || col === null || col === 'Invalid date' || col === "NaN")
            col = "";

          line = line + `"` + col + `";`;
        }
      });

      if (!!addExport)
        // dataExport.push(line);
        dataExport = dataExport + line + `\r\n`;

    });

  // data.map(line => {
  //   line
  // })
  // console.log("data", data, dataExport);
  return dataExport;
};

function formatDate(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return day + "-" + month + "-" + year;
}

//https://github.com/abdennour/react-csv/blob/master/sample-site/csvdownload.example.md

const WrappedDock = ({ dock }) => {
  return <React.Fragment>{dock.map(button => button)}</React.Fragment>;
};

const DownloadButton = ({
  exportToggle,
  tableName,
  type,
  toggleExport,
  dataExport,
  intl
}) => {
  // console.log('FiltersButton', toggledOn, toggle);

  // console.log('310 - tableName=', tableName);
  // console.log('311 - dataExport=', dataExport);
  // console.log('312 - toggleExport=', toggleExport);

  //.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleUpperCase('en-US')

  let fileName;
  if (tableName)
    fileName =
      "NW-" +
      intl.formatMessage({ id: `ids_` + tableName }) +
      (type !== undefined ? "-" + intl.formatMessage({ id: `ids_` + type }) : "") +
      "-" +
      formatDate(new Date());
  else fileName = "TableauNetwips";
  return (
    <CSVLink data={dataExport} filename={fileName + ".csv"} separator={";"}>
      {/* {console.log("TABLENAME", tableName)} */}
      <CustomButton icon pullRight onClick={toggleExport}>
        <img src={exelIcon} alt="" style={{ width: "16px" }} />
        <FormattedMessage id="ids_export" />
      </CustomButton>
    </CSVLink>
  );
};

const FiltersButton = ({ toggledOn, toggle }) => {
  // console.log('FiltersButton', toggledOn, toggle);
  return (
    <div onClick={toggle}>
      {toggledOn && (
        <CustomButton icon pullRight>
          <i className="fa fa-times" aria-hidden="true" />
          <FormattedMessage id="ids_hideFilters" />
        </CustomButton>
      )}
      {!toggledOn && (
        <CustomButton icon pullRight>
          <i className="fa fa-filter" aria-hidden="true" />
          <FormattedMessage id="ids_filter" />
        </CustomButton>
      )}
    </div>
  );
};

const LettrageButton = ({
  // atLeastOneExpenseSelected,
  // atLeastOneInvoiceSelected,
  // atLeastOneBankTransactionSelected,
  // atLeastOneBankTransactionWithLettrage,
  // atLeastOneBankTransactionWithoutLettrage,
  // atLeastOneEcartSelected,
  showEmptyButton,
  enableLettrer,
  enableDelettrer,
  enablePayer,
  enableRelancer,
  enableReaffecterCategory,
  enableReaffecterClientProject,
  enableReaffecterOnlyProject,
  enableClasserSansSuite,
  enableResetAux,
  enableGetHistory,
  enableGetHistory2,
  enableCreateBudgetBackup,
  enableGetSoldeTiers,
  hideTotal,
  cumulValue,
  currencyId,
  lettrageManuel,
  delettrageManuel,
  payer,
  relancer,
  reaffecterCategory,
  reaffecterClientProject,
  reaffecterOnlyProject,
  classerSansSuite,
  resetClientAux,
  resetSupplierAux,
  getHistory,
  getHistory2,
  createBudgetBackup,
  getSoldeTiers,
  showDuplicateExpense,
  duplicateExpense
}) => {
  //<i className="fa fa-list" aria-hidden="false" />

  // console.log("401 - enableLettrer=", enableLettrer);
  // console.log("402 - enableDelettrer=", enableDelettrer);
  // console.log("403 - enablePayer=", enablePayer);
  // console.log("404 - enableRelancer=", enableRelancer);
  // console.log("405 - enableReaffecterCategory=", enableReaffecterCategory);
  // console.log("406 - enableResetAux=", enableResetAux);

  return enableLettrer === true ||
    enableDelettrer === true ||
    enablePayer === true ||
    enableRelancer === true ||
    enableReaffecterCategory === true ||
    enableReaffecterClientProject === true ||
    enableReaffecterOnlyProject === true ||
    enableResetAux === true ||
    enableGetHistory === true ||
    enableGetHistory2 === true ||
    enableCreateBudgetBackup === true ||
    enableGetSoldeTiers === true ||
    enableClasserSansSuite === true ||
    showDuplicateExpense === true ? (
    <div className="pull-right">
      <Dropdown
        id="dropdown-save-btn"
        disabled={false}
        //id="expense-validation-dropdown"
        className="dropdown-action-btn"
      >

        {hideTotal !== true ? (
          <Dropdown.Toggle className="btn-wd btn-icon">
            <FormattedMessage id="ids_action" />  {" "}(
            <FormattedMessage id="ids_total" /> : {" "}
            < CurrencySpan currencyId={currencyId} value={cumulValue} showNull={true} />)
          </Dropdown.Toggle>
        ) : (
          <Dropdown.Toggle className="btn-wd btn-icon">
            <FormattedMessage id="ids_action" />
          </Dropdown.Toggle>
        )}

        <Dropdown.Menu className="action-dropdown-menu">
          {enableLettrer ? (
            <MenuItem onClick={lettrageManuel} eventKey="2">
              <i className="fa fa-lg  fa-check" />
              <FormattedMessage id="ids_lettrer" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableDelettrer ? (
            <MenuItem onClick={delettrageManuel} eventKey="3">
              <i className="fa fa-lg  fa-times" />
              <FormattedMessage id="ids_delettrer" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enablePayer ? (
            <MenuItem
              // disabled
              onClick={payer}
              eventKey="4"
            >
              <i className="fa fa-lg fa-money" />
              <FormattedMessage id="ids_payer" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableRelancer ? (
            <MenuItem
              // disabled
              onClick={relancer}
              eventKey="5"
            >
              <i className="fa fa-lg fa-bell" />
              <FormattedMessage id="ids_relancer" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableReaffecterCategory ? (
            <MenuItem
              // disabled
              onClick={reaffecterCategory}
              eventKey="6"
            >
              <i className="fa fa-lg fa-caret-right" />
              <FormattedMessage id="ids_reaffectCategory" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableReaffecterClientProject ? (
            <MenuItem
              // disabled
              onClick={reaffecterClientProject}
              eventKey="7"
            >
              <i className="fa fa-lg fa-caret-right" />
              <FormattedMessage id="ids_reaffectClientProject" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableReaffecterOnlyProject ? (
            <MenuItem
              // disabled
              onClick={reaffecterOnlyProject}
              eventKey="8"
            >
              <i className="fa fa-lg fa-caret-right" />
              <FormattedMessage id="ids_reaffectOnlyProject" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableClasserSansSuite ? (
            <MenuItem
              // disabled
              onClick={classerSansSuite}
              eventKey="9"
            >
              <i className="fa fa-lg fa-ban" />
              <FormattedMessage id="ids_dropQuotation" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableResetAux ? (
            <MenuItem
              // disabled
              onClick={resetClientAux}
              eventKey="10"
            >
              <i className="fa fa-lg fa-refresh" />
              <FormattedMessage id="ids_resetClientAux" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableResetAux ? (
            <MenuItem
              // disabled
              onClick={resetSupplierAux}
              eventKey="11"
            >
              <i className="fa fa-lg fa-refresh" />
              <FormattedMessage id="ids_resetSupplierAux" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableGetHistory ? (
            <MenuItem
              // disabled
              onClick={getHistory}
              eventKey="12"
            >
              <i className="fa fa-lg fa-download" />
              <FormattedMessage id="ids_getHistoryBudget" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableGetHistory2 ? (
            <MenuItem
              // disabled
              onClick={getHistory2}
              eventKey="13"
            >
              <i className="fa fa-lg fa-download" />
              <FormattedMessage id="ids_getHistoryBudget2" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableCreateBudgetBackup ? (
            <MenuItem
              // disabled
              onClick={createBudgetBackup}
              eventKey="14"
            >
              <i className="fa fa-lg fa-floppy-o" />
              <FormattedMessage id="ids_createBudgetBackup" />
            </MenuItem>
          ) : (
            <div />
          )}

          {enableGetSoldeTiers ? (
            <MenuItem
              // disabled
              onClick={getSoldeTiers}
              eventKey="15"
            >
              <i className="fa fa-lg fa-download" />
              <FormattedMessage id="ids_getSoldeTiers" />
            </MenuItem>
          ) : (
            <div />
          )}

          {showDuplicateExpense ? (
            <MenuItem
              // disabled
              onClick={duplicateExpense} //duplicateExpense}
              eventKey="9"
            >
              <i className="fa fa-lg fa-plus" />
              <FormattedMessage id="ids_duplicate" />
            </MenuItem>
          ) : (
            <div />
          )}

        </Dropdown.Menu>
      </Dropdown>
      {/* <CustomButton icon pullRight onClick={lettrageManuel}>        
        <FormattedMessage id="ids_lettrage" /> (<FormattedMessage id="ids_total" />:{cumulValue})
      </CustomButton>  */}
    </div>
  ) : (
    showEmptyButton ? (
      <div className="pull-right">
        <Dropdown
          id="dropdown-save-btn"
          disabled={false}
          className="dropdown-action-btn"
        >
          <Dropdown.Toggle className="btn-wd btn-icon">
            <FormattedMessage id="ids_total" /> :{" "}
            <CurrencySpan currencyId={currencyId} value={cumulValue} showNull={true} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    )
      : (
        <div />
      )
  )
};

const RequestAllOrOneButton = ({
  requestOnlyOnePageToggle,
  setRequestOnlyOnePageToggle,
  pageSize
}) => {

  // console.log("513 - requestOnlyOnePageToggle=", requestOnlyOnePageToggle, pageSize);

  if (requestOnlyOnePageToggle > 0)
    requestOnlyOnePageToggle = 0;
  else
    requestOnlyOnePageToggle = pageSize;

  return (
    <CustomButton
      icon
      pullRight
      onClick={e => {
        setRequestOnlyOnePageToggle(requestOnlyOnePageToggle);
        sessionStorage.setItem(`requestOnlyOnePageToggle`, requestOnlyOnePageToggle);
      }}>
      <i className="fa fa-bars margin-right-5" />
      <FormattedMessage id={requestOnlyOnePageToggle > 0 ? "ids_requestOnePage" : "ids_requestAllPages"} />
    </CustomButton>
  );
};

const handlers = withHandlers({
  trClassFormat: ({ lastVisited }) => row => {
    return row.id === lastVisited ? "last-visited" : "";
  },
  handleRowSelect: ({ onRowSelect, setRowSelected, rowSelected }) => (
    row,
    isSelected
  ) => {
    if (isSelected) {
      onRowSelect([...rowSelected, row].length > 0);
      setRowSelected([...rowSelected, row]);
    } else {
      let reducedList = rowSelected;
      _.remove(reducedList, { id: row.id });
      onRowSelect(reducedList.length > 0);
      setRowSelected(reducedList);
    }
  },
  handleSelectAll: ({ onRowSelect, setRowSelected, data }) => e => {
    onRowSelect(e);
    setRowSelected(e ? data : []);
  },
  print: e => {
    console.log("print", e);
  },
  deleteRows: ({
    deleteRows,
    onRowSelect,
    setRowSelected,
    rowSelected
  }) => () => {
    deleteRows(rowSelected);
    onRowSelect(false);
    setRowSelected([]);
  },
  restoreRows: ({
    restoreRows,
    onRowSelect,
    setRowSelected,
    rowSelected
  }) => () => {
    restoreRows(rowSelected);
    onRowSelect(false);
    setRowSelected([]);
  },
  ...filterHandlers
});

let Table = ({
  data,
  intl,
  tableName,
  type,
  visibleColumns,
  infoCumul,
  onLettrageManuel,
  onDelettrageManuel,
  onPayer,
  onRelancer,
  onReaffecterCategory,
  onReaffecterClientProject,
  onReaffecterOnlyProject,
  onClasserSansSuite,
  onResetClientAux,
  onResetSupplierAux,
  onGetHistory,
  onGetHistory2,
  onCreateBudgetBackup,
  onGetSoldeTiers,
  duplicateExpense,
  trClassFormat,
  onRowClick,
  onRowChecked,
  onCellChange,
  requestOnlyOnePageToggle,
  setRequestOnlyOnePageToggle,
  deleteRows,
  restoreRows,
  rowSelected,
  setRowSelected,
  toggledOn,
  filterState,
  setFilterState,
  sortedState,
  setSortedState,
  pageState,
  setPageState,
  pageSizeState,
  setPageSizeState,
  exportToggle,
  toggleExport,
  handleRowSelect,
  handleSelectAll,
  printable,
  sortable,
  filterable,
  deletable,
  exportable,
  restorable,
  defaultSorted,
  dataSelectedCount,
  toggle,
  pivotBy,
  // expanded,
  expandedState,
  onExpandedChange,
  setExpandedState,
  lastVisited,
  defaultPageSize,
  showPagination,
  showFilter,
  locale, // const locale = `${intl.locale.split("-")[0]}`;
  // if (locale !== "en") {
  //   // en is enabled by default already
  //   import(`moment/locale/${locale}`).then(() => {
  //     moment.locale(locale);
  //   });
  // },,
  computedHeight,
  fixHeight,
  windowScrollState,
  scrollable,
  expandAll,
  dock,
  filtersReset,
  setFiltersReset,
  onSortedChange
}) => {

  // console.log("830 - data=", data, tableName, type);

  if (filtersReset === true) {
    setFiltersReset(false);
    setFilterState([]);
  }
  // console.log("829 - onGetSoldeTiers=", onGetSoldeTiers);
  // const locale = `${intl.locale.split("-")[0]}`;
  // if (locale !== "en") {
  //   // en is enabled by default already
  //   import(`moment/locale/${locale}`).then(() => {
  //     moment.locale(locale);
  //   });
  // }

  useEffect(() => {
    if (windowScrollState) window.scroll(0, windowScrollState);
  }, [windowScrollState]);

  // if (locale !== "en") {
  moment.locale(locale);

  // const headers = data && data[0] ? Object.keys(data[0]) : ['id'];
  // const options = {
  // toolBar: () => (
  //   <CustomToolBar
  //     printable={printable}
  //     deletable={deletable}
  //     exportable={exportable}
  //     restorable={restorable}
  //     dataSelectedCount={dataSelectedCount}
  //     visibleColumns={visibleColumns}
  //     deleteRows={deleteRows}
  //     restoreRows={restoreRows}
  //     rowSelected={rowSelected}
  //   />
  // )
  // };


  const expanded = expandAll ? data.map(x => true) : {};

  Object.assign(ReactTableDefaults, {
    pageSizeOptions: [25, 50, 100, 200],
    defaultPageSize: 100,
    pageText: false,
    previousText: "<",
    nextText: ">",
    showPageJump: true,
    showPagination: true,
    showPaginationTop: false,
    showPaginationBottom: true,
    minRows: 5,
    loading: false,
    expanded,

    // {
    //   0: true, 1: true
    // },
    // minRows: 0,
    defaultSortMethod: (a, b, desc) => {
      // force null and undefined to the bottom

      // if (a && b)
      //   console.log("a=", a, " - b=", b);

      a = a === null || a === undefined ? +Infinity : a;
      b = b === null || b === undefined ? -Infinity : b;

      // force any string values to lowercase
      // a = a === "string" ? a.toUpperCase() : a;
      // b = b === "string" ? b.toUpperCase() : b;
      a = typeof a === "string" ? a.toUpperCase().trim() : a;
      b = typeof b === "string" ? b.toUpperCase().trim() : b;

      if (typeof a === "string") {
        if (a.substr(a.length - 2) === " %") {
          a = parseFloat(a.substr(0, a.length - 2));
        }
      }
      if (typeof b === "string") {
        if (b.substr(b.length - 2) === " %") {
          b = parseFloat(b.substr(0, b.length - 2));
        }
      }

      // console.log('a:', a, 'b:', b, ' -----> ', a>b)
      if (a === -Infinity) return -1;
      if (b === -Infinity) return 1;

      // Return either 1 or -1 to indicate a sort priority
      if (a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
      // returning 0, undefined or any falsey value will use subsequent sorts or the index as a tiebreaker
      return 0;
    }
  });

  const dataSelected = _.filter(data, o => {
    return o.selected;
  });
  // console.log("934 - dataSelected=", dataSelected);


  const statusInfo = {
    PAYE: {
      translation: intl.formatMessage({ id: `ids_paid` }),
      statusColor: "text-success"
    },
    ENRETARD: {
      translation: intl.formatMessage({ id: `ids_delayed` }),
      statusColor: "text-warning"
    },
    BROUILLON: {
      translation: intl.formatMessage({ id: `ids_draft` }),
      statusColor: "text-danger"
    },
    EMISE: {
      translation: intl.formatMessage({ id: `ids_issued` }),
      statusColor: "text-warning"
    },
    DUE: {
      translation: intl.formatMessage({ id: `ids_due` }),
      statusColor: "text-warning"
    },
    FACTURE: {
      translation: intl.formatMessage({ id: `ids_billed` }),
      statusColor: "text-success"
    },
    ACCEPTE: {
      translation: intl.formatMessage({ id: `ids_accepted` }),
      statusColor: "text-danger"
    },
    ENATTENTE: {
      translation: intl.formatMessage({ id: `ids_waiting` }),
      statusColor: "text-warning"
    },
    SANSSUITE: {
      translation: intl.formatMessage({ id: `ids_dropped` }),
      statusColor: "text-danger"
    },

    project_table_active_true: {
      translation: intl.formatMessage({ id: `ids_active` }),
      statusColor: "text-success"
    },
    project_table_active_false: {
      translation: intl.formatMessage({ id: `ids_inactive` }),
      statusColor: "text-warning"
    },
    // category_table_active_true: {
    //   translation: intl.formatMessage({ id: `category_table_active_true` }),
    //   statusColor: "text-success"
    // },
    // category_table_active_false: {
    //   translation: intl.formatMessage({ id: `category_table_active_false` }),
    //   statusColor: "text-warning"
    // },
    ACOMPLETER: {
      translation: intl.formatMessage({ id: `ids_toComplete` }),
      statusColor: "text-primary"
    },
    AVALIDER: {
      translation: intl.formatMessage({ id: `ids_toValidate` }),
      statusColor: "text-danger"
    },
    REFUSE: {
      translation: intl.formatMessage({ id: `ids_refused` }),
      statusColor: "text-secondary"
    },
    APAYER: {
      translation: intl.formatMessage({ id: `ids_toPay` }),
      statusColor: "text-warning"
    },
    // PAYER: {
    //   translation: intl.formatMessage({ id: `ids_paid` }),
    //   statusColor: "text-warning"
    // },
    NONE: {
      translation: intl.formatMessage({ id: `ids_none` }),
      statusColor: "text-muted"
    },
    ENCAISSEMENT: {
      translation: intl.formatMessage({ id: `ids_encaissement` }),
      statusColor: "text-primary"
    },
    DEBIT: {
      translation: intl.formatMessage({ id: `ids_debit` }),
      statusColor: "text-primary"
    }

    // PAYE: {
    //   translation: intl.formatMessage({ id: `expense_status_PAYE` }),
    //   statusColor: 'text-info'
    // },
    // ENRETARD: {
    //   translation: intl.formatMessage({ id: `expense_status_ENRETARD` }),
    //   statusColor: 'text-info'
    // }
  };

  // const buildToolTip = text => (
  //   <Tooltip>
  //     <p>{text}</p>
  //   </Tooltip>
  // );

  let columns = [];
  let exportColumns = [];
  visibleColumns.map(column => {

    let newColumn = {
      type: "string",
      filterable: toggledOn,
      ...column,
      sortable: true
    };
    // console.log('802 - column', column);
    // if (column.type === undefined) newColumn.type = "string";
    // if (column.id !== undefined) newColumn.id = column.id;

    if (column.accessor !== undefined) newColumn.accessor = column.accessor;
    else newColumn.accessor = column.name;

    if (column.Expander !== undefined) newColumn.Expander = column.Expander;
    if (column.expander !== undefined) newColumn.expander = column.expander;
    if (column.pivot !== undefined) newColumn.pivot = column.pivot;

    // if (column.style !== undefined) newColumn.style = column.style;

    newColumn.Header =
      column.noTranslateColumnName === true
        ? column.name
        : intl.formatMessage({
          id: `ids_${column.name}`
        });

    // console.log("918 - newColumn=", newColumn);
    switch (newColumn.type) {
      case "numeroPiece":
        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            // console.log("cell projectActive", row);
            // return row.value;
            const translation = statusInfo[row.value];

            if (translation) {
              return <div>{translation.translation}</div>;
            } else {
              return <div>{row.value}</div>;
            }
          };

        if (newColumn.filterMethod === undefined)
          newColumn.filterMethod = (filter, row) => {
            if (!filter.value) return true;
            return row[filter.id]
              ? row[filter.id]
                .toString()
                .toUpperCase()
                .includes(filter.value.toUpperCase())
              : false;
          };

        break;

      case "tax":
        if (column.maxWidth === undefined) newColumn.maxWidth = "100";
        newColumn.style = {
          textAlign: "right"
        };
        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            // console.log("tax cell", row);
            return <span>{row.value ? row.value.toFixed(2) : 0} %</span>;
          };

        break;

      case "switch":
        if (column.maxWidth === undefined) newColumn.maxWidth = "100";
        newColumn.style = {
          textAlign: "center"
        };
        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            return (
              <Switch
                onText="✔"
                offText="✘"
                disabled={true}
                value={row.value}
              />
            );
          };
        break;

      case "checkbox":
        if (column.maxWidth === undefined)
          newColumn.maxWidth = "60";

        newColumn.style = {
          textAlign: "center"
        };
        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            return (
              <Checkbox
                style={{ marginTop: "0px", marginBottom: "0px" }}
                intable={true}
                number={v4() + "/" + row.index}
                isChecked={row.original.selected || false}
                onCheck={(value) => onRowChecked(
                  row,
                  value
                )}
              />
            );
          };
        break;

      case "date":
        if (column.maxWidth === undefined) newColumn.maxWidth = "100";
        if (column.Cell === undefined) {
          newColumn.Cell = row => {
            // console.log("cell date", row);
            // console.log("locale", locale, moment.locale());

            //return row.value ? moment(row.value).format("L") : "";
            return (
              <div>
                {row.value
                  ? moment(row.value).format(
                    column.dateFormat ? column.dateFormat : "L"
                  )
                  : ""}
              </div>
            );
          };
          if (newColumn.filterMethod === undefined)
            newColumn.filterMethod = (filter, row) => {
              // console.log("813 - filter:", filter, " row:", row, row[filter.id]);
              if (!filter.value) return true;

              if (!!row[filter.id]) {
                return moment(row[filter.id])
                  .format("L")
                  .includes(filter.value);
              }

              return false;
            };
        }

        break;

      case "projectActive":
        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            // console.log("cell projectActive", row);
            // return row.value;
            const info =
              statusInfo[
              row.value
                ? "project_table_active_true"
                : "project_table_active_false"
              ];

            return (
              <div className={info.statusColor}>
                {info.translation}
                {/* {intl.formatMessage({ id: `expense_status_${row.value}` })} */}
              </div>
            );
          };
        break;

      case "categoryActive":
        newColumn.style = {
          textAlign: "center"
        };
        if (newColumn.Cell === undefined)
          if (column.maxWidth === undefined) newColumn.maxWidth = "100";
        newColumn.Cell = row => {
          // console.log("cell projectActive", row);
          // return row.value;
          const info =
            statusInfo[
            !!row.value
              ? "project_table_active_true"
              : "project_table_active_false"
            ];
          let rend;
          // console.log("row", row);
          if (row.original) {
            rend = row.value ? (
              <span
                style={{
                  color: "white",
                  backgroundColor: "#87cb16",
                  padding: "5px",
                  paddingRight: "18px",
                  paddingLeft: "18px",
                  borderRadius: "2px"
                }}
              >
                {_.capitalize(info.translation)}
              </span>
            ) : (
              <span
                style={{
                  /*color: "grey"*/
                  color: "white",
                  backgroundColor: "grey",
                  padding: "5px",
                  paddingRight: "15px",
                  paddingLeft: "15px",
                  borderRadius: "2px"
                }}
              >
                {_.capitalize(info.translation)}
              </span>
            );
          } else {
            rend = <div />;
          }

          return (
            <div className={info.statusColor}>
              {rend /*info.translation*/}
              {/* {intl.formatMessage({ id: `expense_status_${row.value}` })} */}
            </div>
          );
        };
        break;

      case "status":
        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            // console.log("cell status", row);
            // return row.value;

            return (
              <div
                className={row.value && statusInfo[row.value].statusColor}
                style={{ textAlign: "center" }}
              >
                {row.value && statusInfo[row.value].translation}
                {/* {intl.formatMessage({ id: `expense_status_${row.value}` })} */}
              </div>
            );
          };

        if (column.maxWidth === undefined) newColumn.maxWidth = "100";

        if (newColumn.filterMethod === undefined)
          newColumn.filterMethod = (filter, row) => {
            // return false; //////// TODO: REMOVE
            // console.log(
            //     'filter:',
            //     filter,
            //     ' row:',row,
            //     row[filter.id]
            //   );

            //   console.log('filter currency', row[filter.id].toUpperCase(), filter.value.toUpperCase());
            if (!filter.value) return true;

            if (true) {
              return statusInfo[row[filter.id]].translation
                .toUpperCase()
                .includes(filter.value.toUpperCase());
            } else {
              return true;
            }
          };
        break;

      case "string":
        if (column.textAlign !== undefined) {
          newColumn.style = {
            textAlign: column.textAlign
          };
        }
        if (newColumn.Cell === undefined) {
          newColumn.Cell = row => {
            //return row.value ? moment(row.value).format("L") : "";

            const text = row.value !== undefined ? row.value : "";

            // const toolTip = (
            //   <Tooltip id="tooltip">
            //     <p>{text}</p>
            //     {/* <p>{"toto"}</p> */}
            //   </Tooltip>
            // );

            if (newColumn.email) {
              return (
                <a title={text} href={`mailto:${text}`}>
                  {text}
                </a>
              );
            }
            if (newColumn.tel) {
              return (
                <a title={text} href={`tel:${text}`}>
                  {formatPhoneNumber("" + text, undefined, "International")}
                </a>
              );
            }
            return (
              <div title={text}>
                {text}
                {/* <OverlayTrigger placement="top">{text}</OverlayTrigger> */}
              </div>
            );

            // return <div>{row.value !== undefined ? row.value : ""}</div>;

            // console.log("Cell string", row.value, row);
            //return row.value !== undefined ? row.value : "";
          };
        }

        if (newColumn.filterMethod === undefined) {
          newColumn.filterMethod = (filter, row) => {
            // return false; //////// TODO: REMOVE
            // console.log("\nfilterMethod. filter:", filter, " row:", row);
            //   console.log('filter currency', row[filter.id].toUpperCase(), filter.value.toUpperCase());
            if (!filter.value) return true;
            // if (row[filter.id])
            //   return row[filter.id]
            //     .toString()
            //     .toUpperCase()
            //     .includes(filter.value.toUpperCase());
            // if (!!row._pivotID && filter.id === row._pivotID) {
            //   // pivot match, have to check value
            //   const val = row._pivotVal.toString().toUpperCase();
            //   const included = filter.value.toUpperCase();
            //   const res = val.includes(included);
            //   console.log(
            //     "COMPARE PIVOT",
            //     `[${val}] inc  [${included}] = ${res}`
            //   );
            //   return res;
            // }
            if (row._subRows) {
              const res = row._subRows.map(elem => {
                return newColumn.filterMethod(filter, elem);
              });
              if (res.some(v => v)) {
                return true;
              }
            }

            // not a pivot
            if (row[filter.id])
              return row[filter.id]
                .toString()
                .toUpperCase()
                .includes(filter.value.toUpperCase());

            return false;
          };
        }
        break;

      case "currency":
        // console.log("currency column", column, );
        // newColumn.accessor = d => column[]  d.friend.name

        newColumn.style = {
          textAlign: "right"
          // width: '100%',
          // height: '100%',
          // backgroundColor: "#dadada",
          // borderRadius: "2px"
        };
        if (column.maxWidth === undefined) newColumn.maxWidth = "120";
        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            //console.log("cell currency", column, row);

            let amount = row.value;
            const digit = row.column.digit;

            if (row.column.currencyMontant) {
              amount = -row.value;
            }

            // no color for debit/credit type, color for montants
            const amountColor = row.column.currencyDebit ||
              row.column.currencyCredit ||
              row.column.noTextColor || newColumn.colored !== true
              ? ""
              : amount < 0
                ? "text-danger"
                : "text-success";

            if (row.column.currencyDebit) {
              // debit display: should show negative values only as positive values
              if (row.value >= 0) {
                amount = row.value;
              } else return "";
            }
            if (row.column.currencyCredit) {
              // console.log("cell currency credit", column, row);
              // debit display: should show posiive values only
              if (row.value < 0) amount = -row.value;
              else return "";
            } else {
            }

            let currency = row.original && row.original.currency;
            if (!currency && row.column.currency !== undefined)
              currency = row.column.currency;
            const content = currency ? (
              <CurrencySpan
                textColor={amountColor}
                digit={digit}
                currencyId={currency.id}
                value={amount}
              />
            ) : (
              // fallback when currency isnt set
              <CurrencySpan
                textColor={amountColor}
                digit={digit}
                value={row.value}
              />
            );

            const renderBadges = row.column.badges;
            return (
              <span>
                <React.Fragment>
                  {content} {renderBadges && renderBadges(row.original)}{" "}
                </React.Fragment>
              </span>
            );
          };

        const filterMethod = (newColumn.filterMethod = (filter, row) => {

          // console.log("1157 - row=", row);
          if (row._subRows) {
            const res = row._subRows.map(elem => {
              return filterMethod(filter, elem);
            });
            if (res.some(v => v)) {
              return true;
            }
          }
          const regex1 = /(\d+)\.$/i; // remove .
          const regex2 = /(\d+)\.0$/i; // remove .0
          const regex3 = /(\d+\.\d)0$/i; // remove last 0 in .\d0
          let filtered = filter.value.replace(regex1, "$1");
          //filtered = filtered.replace(regex2, "$1");
          //filtered = filtered.replace(regex3, "$1");
          filtered = filtered.replace(",", ".");

          return (
            (row[filter.id] && row[filter.id].toString().includes(filtered)) ||
            false
          );
        });

        break;

      case "edit":
        // newColumn.style = {
        //   textAlign: "right"
        // };

        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            let rowKeys = Object.keys(row); ///console.log("Keys:", rowKeys);
            let rowValues = Object.values(row); //console.log("Values:", rowValues);

            let cellIndex = rowKeys.indexOf("original");
            let accountId = rowValues[cellIndex].id;

            cellIndex = rowKeys.indexOf("column");
            let fieldName = rowValues[cellIndex].id;

            return (
              <SmallInputCell
                key={row.index}
                value={row.value || " "}
                fieldName={fieldName}
                row={row}
                onBlur={e => {
                  onCellChange(accountId, fieldName, e, row.index);
                  console.log("Blur: e=", e);
                }}
                onFocus={e => e.target.select()}
              />
            );
          };

        if (newColumn.filterMethod === undefined)
          newColumn.filterMethod = (filter, row) => {
            // console.log("toto", filter, row);
            if (!filter.value) {
              return true;
            }
            return row[filter.id]
              ? row[filter.id]
                .toString()
                .toUpperCase()
                .includes(filter.value.toUpperCase())
              : false;
          };
        break;

      default:
        if (newColumn.Cell === undefined)
          newColumn.Cell = row => {
            //console.log("default Cell", row);
            return row.value;
          };
    }

    //console.log('column', newColumn);
    if (column.visible !== false)
      columns.push(newColumn);

    exportColumns.push(newColumn);
    return newColumn;
  });

  const dimension = viewPortDimension();
  console.log("dimension", dimension);
  let tableHeight = computedHeight
    ? computedHeight
    : dimension.height - (dimension.width > 892 ? 250 : 500);
  console.log("cmputedHeight", computedHeight);

  const onRowClickLocal = (state, rowInfo, column, instance) => {
    let textDecoration =
      rowInfo && rowInfo.original && rowInfo.original.isDeleted === true
        ? "line-through"
        : "Inherit";

    let textColor = "Inherit";

    if (
      rowInfo &&
      rowInfo.original &&
      rowInfo.original.providerTransaction === null &&
      rowInfo.original.bankAccount &&
      (
        rowInfo.original.bankAccount.syncAccount === true ||
        rowInfo.original.bankAccount.importedAccount === true
      )
    ) {
      textColor = "DarkGrey";
    }

    if (
      rowInfo &&
      rowInfo.original &&
      rowInfo.original.bankTransaction &&
      rowInfo.original.bankTransaction.providerTransaction === null &&
      (
        rowInfo.original.bankTransaction.bankAccount && (
          rowInfo.original.bankTransaction.bankAccount.syncAccount === true ||
          rowInfo.original.bankTransaction.bankAccount.importedAccount === true)
      )
    ) {
      textColor = "DarkGrey";
    }

    if (
      rowInfo &&
      rowInfo.original &&
      rowInfo.original.expense
    ) {
      if (rowInfo.original.expense.status === "REFUSE") {
        textColor = "Red";
      }
      else if (rowInfo.original.expense.status === "AVALIDER") {
        textColor = "DarkGrey";
      }
    }

    // if (
    //   rowInfo &&
    //   rowInfo.original &&
    //   rowInfo.original.selected === true
    // ) {
    //   textColor = "Yellow";
    // }

    // const selectdStyle = {
    //   background: rowInfo.index === rowSelected ? "#00afec" : "white",
    //   color: rowInfo.index === rowSelected ? "white" : "black"
    // };

    // console.log("rowinfo", rowInfo, lastVisited);
    const isLastVisited =
      (rowInfo &&
        rowInfo.original &&
        rowInfo.original.id &&
        rowInfo.original.id === lastVisited) ||
      (rowInfo &&
        rowInfo.original &&
        rowInfo.original.node &&
        rowInfo.original.node.id === lastVisited);
    let style = {
      textDecoration: textDecoration,

      color: textColor,
      cursor: "pointer"
    };
    if (isLastVisited) {
      style.background = "#d2f0f5";
    }

    // console.log("1299 - col=", rowInfo, column );

    return {
      style,
      onClick: (e, handleOriginal) => {
        if (handleOriginal) {
          handleOriginal();
        }

        saveState(
          tableName,
          toggledOn,
          filterState,
          sortedState,
          pageState,
          pageSizeState,
          expandedState
        );

        if (rowInfo && rowInfo.original) {
          if (!rowInfo.original.isDeleted) {
            const id =
              rowInfo.original.node && rowInfo.original.node.id
                ? rowInfo.original.node.id
                : rowInfo.original.id;
            // console.log("onRowClickLocal", rowInfo, id);
            sessionStorage.setItem(`${tableName}TableLastVisited`, id);
            setRowSelected(rowInfo.original.id);

            if (column.id !== "checkboxSelection")
              onRowClick && onRowClick(id, state, rowInfo, column, instance);
          }
        }
      }
    };
  };

  const dataExport = convertToCsvExport(exportColumns, data, intl, locale, filterState, sortedState);

  if (defaultPageSize === undefined) {
    // compute based on data
    defaultPageSize = Math.max(5, Math.min((data && data.length) || 0, 100));
  }

  let style = {
    //   height: `${tableHeight}px` // This will force the table body to overflow and scroll, since there is not enough room
  };

  if (fixHeight !== false) {
    style = {
      //      height: `${tableHeight}px` // This will force the table body to overflow and scroll, since there is not enough room
    };
  }

  const isFilterable = filterable !== undefined ? !!filterable : true;
  const isExportable = exportable !== undefined ? !!exportable : true;

  if (scrollable) {
    style.height = `${tableHeight}px`; // This will force the table body to overflow and scroll, since there is not enough room
  }

  // console.log("1373 - pageSizeState=", pageSizeState)
  // defaultPageSize = 5;
  // const minRows = defaultPageSize;
  return (
    <Grid fluid>
      <Row>
        {isExportable && (
          <DownloadButton
            intl={intl}
            type={type}
            tableName={tableName}
            toggleExport={toggleExport}
            exportToggle={exportToggle}
            dataExport={dataExport}
          />
        )}
        {isFilterable && (
          <FiltersButton toggledOn={toggledOn} toggle={toggle} />
        )}
        {dock && <WrappedDock dock={dock} />}
        {setRequestOnlyOnePageToggle &&
          <RequestAllOrOneButton
            setRequestOnlyOnePageToggle={setRequestOnlyOnePageToggle}
            requestOnlyOnePageToggle={requestOnlyOnePageToggle}
            pageSize={(pageSizeState === null || pageSizeState === undefined) ? defaultPageSize : pageSizeState}
          />
        }
        <LettrageButton
          showEmptyButton={
            infoCumul && infoCumul.showEmptyButton
          }
          enableLettrer={
            infoCumul && infoCumul.enableLettrer
          }
          enableDelettrer={
            infoCumul && infoCumul.enableDelettrer
          }
          enablePayer={
            infoCumul && infoCumul.enablePayer
          }
          enableRelancer={
            infoCumul && infoCumul.enableRelancer
          }
          enableReaffecterCategory={
            infoCumul && infoCumul.enableReaffecterCategory
          }
          enableReaffecterClientProject={
            infoCumul && infoCumul.enableReaffecterClientProject
          }
          enableReaffecterOnlyProject={
            infoCumul && infoCumul.enableReaffecterOnlyProject
          }
          enableClasserSansSuite={
            infoCumul && infoCumul.enableClasserSansSuite
          }
          enableResetAux={
            onResetClientAux !== undefined || onResetSupplierAux !== undefined
          }
          enableGetHistory={
            onGetHistory !== undefined
          }
          enableGetHistory2={
            onGetHistory2 !== undefined
          }
          enableCreateBudgetBackup={
            onCreateBudgetBackup !== undefined
          }
          enableGetSoldeTiers={
            onGetSoldeTiers !== undefined
          }
          showDuplicateExpense={
            dataSelected.length === 1 && tableName === "expenses"
          }

          cumulValue={infoCumul && infoCumul.cumul}
          currencyId={infoCumul && infoCumul.currencyId}
          lettrageManuel={onLettrageManuel}
          delettrageManuel={onDelettrageManuel}
          payer={onPayer}
          relancer={onRelancer}
          reaffecterCategory={onReaffecterCategory}
          reaffecterClientProject={onReaffecterClientProject}
          reaffecterOnlyProject={onReaffecterOnlyProject}
          classerSansSuite={onClasserSansSuite}
          resetClientAux={onResetClientAux}
          resetSupplierAux={onResetSupplierAux}
          getHistory={onGetHistory}
          getHistory2={onGetHistory2}
          createBudgetBackup={onCreateBudgetBackup}
          getSoldeTiers={onGetSoldeTiers}
          duplicateExpense={o => duplicateExpense(dataSelected[0])}
          hideTotal={onCreateBudgetBackup !== undefined || onGetSoldeTiers !== undefined || onGetHistory !== undefined || onGetHistory2 !== undefined || onResetClientAux !== undefined || onResetSupplierAux !== undefined}
        />

      </Row>
      {/* <div className="position-relative"> */}
      <ReactTable
        filterable={!!filterable ? filterable : false}
        data={data}
        columns={columns}
        className="-striped -highlight"
        style={style}
        page={pageState !== null ? pageState : 0}
        filtered={filterState !== null ? filterState : []}
        //getTrProps={onRowClickLocal}
        getTdProps={onRowClickLocal}
        defaultSorted={sortedState !== null ? sortedState : defaultSorted}
        // defaultPageSize={defaultPageSize}
        // minRows={defaultPageSize}
        pivotBy={pivotBy ? pivotBy : undefined}
        // onExpandedChange={onExpandedChange && onExpandedChange}
        expanded={
          expandedState ? expandedState : expanded ? expanded : undefined
        }
        showPagination={showPagination !== undefined ? showPagination : true}
        pageSize={showPagination !== undefined ? (pageSizeState ? pageSizeState : defaultPageSize) : (pageSizeState ? pageSizeState : undefined)}
        onFilteredChange={(filtered, column) => {
          // sessionStorage.setItem(`${tableName}TableStateToggleOn`, !toggledOn);

          // console.log("1401 - onFilterchange", filtered, column);
          setFilterState(filtered);
          setPageState(0);
          window.scroll(0, 0);
        }}
        onPageChange={pageIndex => {
          console.log("onPageChange", pageIndex);
          setPageState(pageIndex);
          window.scroll(0, 0);
        }}
        onPageSizeChange={(pageSize, pageIndex) => {
          console.log("onPageSizeChange", pageSize, pageIndex);
          setPageSizeState(pageSize);
          sessionStorage.setItem(`TableStatePageSize`, pageSize);
        }}
        onSortedChange={(newSorted, column, shiftKey) => {
          console.log("onSortedChange", newSorted, column, shiftKey);
          setSortedState(newSorted);

          if (onSortedChange) {
            onSortedChange(newSorted);
          }
        }}
        onExpandedChange={(newExpanded, index, event) => {
          console.log("onExpandedChange", newExpanded, index, event);
          setExpandedState(newExpanded);
          onExpandedChange && onExpandedChange(newExpanded, index, event);
        }}
        onResizedChange={(newResized, event) => {
          // console.log("onResizeChange", newResized, event);
        }}
        PaginationComponent={Pagination}
      />
      {/* </div> */}
    </Grid>
  );
};

// Table.propTypes = {
//   data: PropTypes.array,
//   intl: PropTypes.object,
//   tableName: PropTypes.string,
//   visibleColumns: PropTypes.array,
//   trClassFormat: PropTypes.func,
//   onRowClick: PropTypes.func,
//   deleteRows: PropTypes.func,
//   restoreRows: PropTypes.func,
//   rowSelected: PropTypes.array,
//   handleRowSelect: PropTypes.func,
//   handleSelectAll: PropTypes.func,
//   printable: PropTypes.bool,
//   deletable: PropTypes.bool,
//   exportable: PropTypes.bool,
//   restorable: PropTypes.bool,
//   dataSelectedCount: PropTypes.array,
//   toggleOn: PropTypes.bool,
//   toogle: PropTypes.func,
//   defaultSorted: PropTypes.array
// };

// const injectIntlDecorator = _.curryRight(injectIntl);

const enhancedTable = compose(
  withRouter,
  // injectIntlDecorator(),
  rowSelected,
  lastVisitedState,
  filterState,
  sortedState,
  expandedState,
  windowScrollState,
  pageState,
  pageSizeState,
  toggledOn,
  exportToggle,
  tableState,
  handlers,
  pure
  // )(Table);
)(Table);

export default injectIntl(enhancedTable);
